import { Component } from '../Component';
import { ArgSpecDictionary } from '../ComponentUtils';
import gsap from 'gsap';
import { rosAnimation, STAnimationType } from '../../utils/ScrollTriggerHelper';

const DEBUG_VERBOSE: boolean = false;
export const HHDSMapGridTagName: string = 'hhds-map-grid';
const TAG_NAME: string = HHDSMapGridTagName;
const LOG_PREFIX: string = `[${TAG_NAME}]`;

export const HHDSMapGridAttrNames = {
	rosAnimation: 'ros-animation',
};

const Attrs = HHDSMapGridAttrNames;

export class HHDSMapGrid extends Component {
	private imagesContainerTween: gsap.core.Tween | null = null;

	constructor() {
		super();
	}

	protected override init(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'init');

		const html: string = /* html */ `
      <div class="container">
				<div class="${TAG_NAME}">
					<slot></slot>
				</div>
			</div>`;

		this.setInnerHtml('', '', html);

		this.observeSlotChanges(true);

		// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

		const imageEls = [...this.querySelectorAll('img')] as HTMLElement[];

		if (this.vars.get<boolean>(Attrs.rosAnimation)) {
			imageEls.forEach((imageEl) => {
				gsap.set(imageEl, { opacity: 0, y: '5%' });
			});

			this.imagesContainerTween?.kill();

			requestAnimationFrame(() => {
				this.imagesContainerTween = rosAnimation(this, STAnimationType.triggered, {
					start: '30%',
					end: '100%',
					onStart: () => {
						imageEls.forEach((imageEl, index) => {
							gsap.to(imageEl, {
								opacity: 1,
								duration: 0.8,
								y: '0%',
								ease: 'power2.out',
								delay: index * 0.3,
							});
						});
					},
				});
			});
		}
	}

	protected override destroy(): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, 'destroy');
		this.imagesContainerTween?.kill();
	}

	override onAttributeChanged(name: string, _oldValue: string, _newValue: string): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onAttributeChanged: ${name}`);
		this.reinit();
	}

	override onSlotChange(_slot: HTMLSlotElement, _elements: HTMLElement[]): void {
		DEBUG_VERBOSE && logger.log(LOG_PREFIX, `onSlotChange`);
	}

	static override argSpecs(): ArgSpecDictionary {
		return ArgSpecs;
	}
}

export const ArgSpecs: ArgSpecDictionary = {
	[Attrs.rosAnimation]: {
		description: 'Enable scroll-triggered animations.',
		defaultValue: true,
		type: Boolean,
	},
};
